var $6e434aa373f128b4$exports = {};
$6e434aa373f128b4$exports = {
    "loading": `Laden...`,
    "loadingMore": `Mehr laden ...`
};


export {$6e434aa373f128b4$exports as default};
//# sourceMappingURL=de-DE.module.js.map
